import { AgentCoreConversationMessage } from '@/shared/api/agentCore/agentCoreApi';

export const RECOVERY_ACCEPTANCE_TIMEOUT_MS = 30_000;

// Absolute ceiling for the post-stream reconciliation loop. Even when the run
// was accepted (there is run evidence or a persisted prompt), a run that never
// produces a completed assistant turn must not be polled forever.
export const RECOVERY_MAX_DURATION_MS = 5 * 60_000;

export const hasExceededRecoveryWindow = (elapsedMs: number): boolean =>
  elapsedMs >= RECOVERY_MAX_DURATION_MS;

export const countUserPrompts = (
  messages: AgentCoreConversationMessage[],
  prompt: string,
): number => {
  const normalizedPrompt = prompt.trim();
  return messages.filter(
    (message) =>
      message.role === 'user' && message.content.trim() === normalizedPrompt,
  ).length;
};

export const hasUserPrompt = (
  messages: AgentCoreConversationMessage[],
  prompt: string,
): boolean => {
  const normalizedPrompt = prompt.trim();
  return messages.some(
    (message) =>
      message.role === 'user' && message.content.trim() === normalizedPrompt,
  );
};

export const shouldStopUnacceptedRecovery = ({
  hasRunEvidence,
  hasPersistedPrompt,
  elapsedMs,
}: {
  hasRunEvidence: boolean;
  hasPersistedPrompt: boolean;
  elapsedMs: number;
}): boolean =>
  !hasRunEvidence &&
  !hasPersistedPrompt &&
  elapsedMs >= RECOVERY_ACCEPTANCE_TIMEOUT_MS;

export const hasCompletedTurnAfterPrompt = (
  messages: AgentCoreConversationMessage[],
  prompt: string,
): boolean => {
  const normalizedPrompt = prompt.trim();
  let promptIndex = -1;

  messages.forEach((message, index) => {
    if (
      message.role === 'user' &&
      message.content.trim() === normalizedPrompt
    ) {
      promptIndex = index;
    }
  });

  return (
    promptIndex >= 0 &&
    messages
      .slice(promptIndex + 1)
      .some(
        (message) =>
          message.role === 'assistant' && Boolean(message.content.trim()),
      )
  );
};
